export const folderEpicrisisUserFrag = `
    id
    name
    surname
    email
    titleAfterName
    titleBeforeName
`;

export const folderEpicrisisFrag = `
    id
    data
    createdAt
    user {
        ${folderEpicrisisUserFrag}
    }
`;
